import React from "react";
import { waUrl } from "../lib/api";

/**
 * Mobile-only sticky bottom CTA bar
 * Two equal-width buttons: Cari Kampus + WhatsApp Counselor
 */
export default function MobileStickyCTA() {
    const scrollToSearch = () => {
        const el = document.getElementById("smart-search");
        if (el) el.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <div
            data-testid="mobile-sticky-cta"
            className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-slate-200 px-3 py-3 grid grid-cols-2 gap-2 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]"
        >
            <button
                data-cta="cta_mobile_assessment"
                data-testid="mobile-cta-assessment"
                onClick={scrollToSearch}
                className="inline-flex items-center justify-center gap-1.5 bg-[#F5A623] text-[#0A1A2F] hover:bg-[#D98F1B] rounded-full py-3 font-bold text-sm transition-all"
            >
                Cari Kampus
            </button>
            <a
                href={waUrl()}
                target="_blank"
                rel="noopener noreferrer"
                data-cta="cta_mobile_whatsapp"
                data-testid="mobile-cta-whatsapp"
                className="inline-flex items-center justify-center gap-1.5 bg-[#25D366] hover:bg-[#1FB454] text-white rounded-full py-3 font-bold text-sm transition-all"
            >
                <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                    <path d="M17.6 6.32A7.85 7.85 0 0 0 12.04 4c-4.42 0-8 3.58-8 8 0 1.41.37 2.79 1.07 4L4 20l4.13-1.08A7.96 7.96 0 0 0 12.04 20c4.42 0 8-3.58 8-8 0-2.14-.83-4.15-2.44-5.68z" />
                </svg>
                WhatsApp
            </a>
        </div>
    );
}
